<template>
<!-- styleCode=> 小图 shop_show_small  大图 shop_show_big -->
  <div class="index-goods" :class="styleCode">
    <div class="goods-list">
      <div class="title">
        <img src="../../../images/icon/hot.png">
        店长推荐
      </div>
      <div class="lovely-title">
        <img v-if="getdatanull(styleCode)" :src="'../../../../static/images/style/'+styleCode +'/title.jpg'">
      </div>
      <ul>
        <li v-for="item in recommend">
          <router-link :to="'/cell/goodsdetail?shopAlias='+item.shopAlias+'&goodsNumber='+item.goodsNumber">
            <div class="goods-pic">
              <img v-if="getdatanull(item.goodsPic)" :src="imgpath()+'/'+item.goodsPic+'?x-oss-process=style/goodsPic'">
              <img v-else src="../../../images/pic.png">
              <div class="line"></div>
              <template v-if="takeoutsData.enableStockLimit">
                <div class="goods-mask" v-if="item.stockNum == 0">已售罄</div>
              </template>
            </div>
            <div class="area">
              <div class="limit">
                <img v-if="item.hadActivityPrice" src="../../../images/goods/icon5.png" />
                <h1 class="text-hide-2">{{item.goodsName}}</h1>
              </div>
              <p class="price"><font>¥</font>{{item.salePrice}}</p>
              <p class="gray"><span v-if="item.hadActivityPrice && getdatanull(item.maxOriginalPrice)">原价<s>¥{{item.maxOriginalPrice}}</s></span></p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="more" v-if="shopStyleData.mainPageCode != 'shop_show_default'">
      <router-link :to="'/cell?shopAlias='+$route.query.shopAlias">查看全部商品</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goods',
  data () {
    return {
      shopAlias: this.$route.query.shopAlias,
      recommend: '',
      styleCode:'',  //模板编码
      takeoutsData:'' //外卖设置
    }
  },
  created() {
  },
  methods: {

  },
  props:{
    goodsList:'',
    mainPageCode:'',
    takeouts:''
  },
  watch:{
  'goodsList': function(data) {
      this.recommend = data;
    },
    'mainPageCode': function(data) {
        this.styleCode = data;
      },
      'takeouts': function(data) {
        this.takeoutsData = data;
      },
    }
}
</script>

<style scoped>
.index-goods .goods-list {
  padding: 0 10px;
  background: #fff;
}
.index-goods .goods-list .title {
  padding-top: 15px;
  font-size: 16px;
  color: #292929;
}
.index-goods .goods-list .title img {
  display: block;
  float: left;
  width: 13px;
  margin: 3px 10px 0 0;
}
.index-goods .goods-list .lovely-title {
  display: none
}
.index-goods .goods-list.goods-list_default {
  padding: 0 0 10px 10px;
}
.index-goods .goods-list.goods-list_default .fr {
  display: block;
  font-size: 11px;
  color: #999;
}
.index-goods .goods-list.goods-list_default .fr img {
  display: block;
  float: right;
  margin: 2px 10px 0 5px;
}
.index-goods .goods-list ul li .goods-pic {
  position: relative;
}
.index-goods .goods-list ul li .goods-pic .line {
  display: none
}
.index-goods .goods-list li:last-child {
  border-bottom: none;
}
.index-goods .goods-list li img {
  display: block;
  width: 100%;
}
.index-goods .goods-list li h1 {
  height: 50px;
  padding: 10px 0;
  font-size: 14px;
  color: #292929;
}
.index-goods .goods-list li .limit {
  position: relative;
}
.index-goods .goods-list li .limit img {
  position: absolute;
  left: 5px;
  top: -9px;
  width: 62px;
  height: 18px;
}

.index-goods .goods-list li p.price {
  line-height: 32px;
  font-size: 18px;
  color: #e2231a;
}
.index-goods .goods-list li p.gray {
  height: 20px;
  line-height: 20px;
  margin-top: -6px;
  font-size: 12px;
  color: #999;
}

/* 小图 */
.index-goods.shop_show_small .goods-list ul li h1 {
  height: 50px;
}
.index-goods.shop_show_small .goods-list ul {
  overflow: hidden;
}
.index-goods.shop_show_small .goods-list ul li {
  float: left;
  width: 49%;
  margin-right: 2%;
  border-bottom: 1px solid #e6e6e6;
}
.index-goods.shop_show_small .goods-list ul li a {
  display: block;
  padding: 15px 0 7px;
}
.index-goods.shop_show_small .goods-list ul li:nth-child(even) {
  margin-right: 0;
}
.index-goods.shop_show_small .goods-list ul li:nth-last-child(2) {
  border-bottom: none;
}

/* 大图 */
.index-goods.shop_show_big .goods-list ul li {
  width: 100%;
  padding: 15px 0 7px;
  border-bottom: 1px solid #e6e6e6;
}

/* 可爱 */
.index-goods.shop_show_lovely .goods-list .title {
  display: none
}
.index-goods.shop_show_lovely .goods-list .lovely-title {
  display: block
}
.index-goods.shop_show_lovely .goods-list .lovely-title img {
  display: block;
  width: 100%;
}
.index-goods.shop_show_lovely .goods-list {
  padding: 0;
  background: #ffdbdf
}
.index-goods.shop_show_lovely .goods-list ul li h1 {
  height: 50px;
}
.index-goods.shop_show_lovely .goods-list ul {
  padding: 0 10px;
  overflow: hidden;
}
.index-goods.shop_show_lovely .goods-list ul li {
  float: left;
  width: 49%;
  margin-right: 2%;
  margin-bottom: 9px;
  border-bottom: 1px solid #e6e6e6;
}
.index-goods.shop_show_lovely .goods-list ul li a {
  display: block;
  background: #fff;
  padding: 5px 5px 15px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.index-goods.shop_show_lovely .goods-list ul li:nth-child(even) {
  margin-right: 0;
}
.index-goods.shop_show_lovely .goods-list ul li:nth-last-child(2) {
  border-bottom: none;
}
.index-goods.shop_show_lovely .goods-list li .limit img {
  left: 0;
}

/* 简约 */
.index-goods.shop_show_simple .goods-list .title {
  display: none
}
.index-goods.shop_show_simple .goods-list .lovely-title {
  display: block
}
.index-goods.shop_show_simple .goods-list .lovely-title img {
  display: block;
  width: 100%;
}
.index-goods.shop_show_simple .goods-list {
  padding: 0;
}
.index-goods.shop_show_simple .goods-list ul li h1 {
  height: 50px;
  color: #666;
}
.index-goods.shop_show_simple .goods-list ul {
  padding: 0 10px;
  overflow: hidden;
}
.index-goods.shop_show_simple .goods-list ul li {
  float: left;
  width: 49%;
  margin-right: 2%;
}
.index-goods.shop_show_simple .goods-list ul li a {
  display: block;
  background: #fff;
  padding: 5px 5px 15px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.index-goods.shop_show_simple .goods-list ul li:nth-child(even) {
  margin-right: 0;
}
.index-goods.shop_show_simple .goods-list ul li:nth-last-child(2) {
  border-bottom: none;
}
.index-goods.shop_show_simple .goods-list li .limit img {
  left: 0;
}
.index-goods.shop_show_simple .goods-list li .goods-pic .line {
  display: block;
  position: absolute;
  left: 5%;
  top: 5%;
  width: 90%;
  height: 90%;
  border: 1px solid #fff;
}
.index-goods.shop_show_simple .goods-list li p.price {
  font-size: 18px;
  color: #292929;
}

/* 美发美甲 */
.index-goods.shop_show_hairAndNail .goods-list .title {
  display: none
}
.index-goods.shop_show_hairAndNail .goods-list .lovely-title {
  display: block
}
.index-goods.shop_show_hairAndNail .goods-list .lovely-title img {
  display: block;
  width: 100%;
}
.index-goods.shop_show_hairAndNail .goods-list {
  padding: 0;
}
.index-goods.shop_show_hairAndNail .goods-list ul li h1 {
  height: 50px;
  color: #666;
}
.index-goods.shop_show_hairAndNail .goods-list ul {
  padding: 0 10px;
  overflow: hidden;
}
.index-goods.shop_show_hairAndNail .goods-list ul li {
  float: left;
  width: 49%;
  margin-right: 2%;
}
.index-goods.shop_show_hairAndNail .goods-list ul li a {
  display: block;
  background: #fff;
  padding: 5px 5px 15px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.index-goods.shop_show_hairAndNail .goods-list ul li:nth-child(even) {
  margin-right: 0;
}
.index-goods.shop_show_hairAndNail .goods-list ul li:nth-last-child(2) {
  border-bottom: none;
}
.index-goods.shop_show_hairAndNail .goods-list li .limit img {
  left: 0;
}
.index-goods.shop_show_hairAndNail .goods-list li .goods-pic {
  padding: 5px;
  background: #fff;
  border: 1px solid #ebebeb;
  box-shadow:5px 5px 0px #f5f5f5
}
.index-goods.shop_show_hairAndNail .goods-list li .goods-pic img {
  padding: 5px;
  border: 1px dashed #ebebeb;
}
.index-goods.shop_show_hairAndNail .goods-list li p.price {
  font-size: 18px;
  color: #292929;
}
/* 养生 */
.index-goods.shop_show_healthNursing .goods-list .title {
  display: none
}
.index-goods.shop_show_healthNursing .goods-list .lovely-title {
  display: block
}
.index-goods.shop_show_healthNursing .goods-list .lovely-title img {
  display: block;
  width: 100%;
}
.index-goods.shop_show_healthNursing .goods-list {
  background: #ecf1ed;
}
.index-goods.shop_show_healthNursing .goods-list ul li h1 {
  height: 50px;
  color: #5e2e31
}
.index-goods.shop_show_healthNursing .goods-list ul {
  overflow: hidden;
}
.index-goods.shop_show_healthNursing .goods-list ul li {
  float: left;
  width: 49%;
  margin: 0 2% 10px 0;
  background: #fff;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  overflow: hidden;
}
.index-goods.shop_show_healthNursing .goods-list ul li a {
  display: block;
  padding-bottom: 15px;
}
.index-goods.shop_show_healthNursing .goods-list ul li:nth-child(even) {
  margin-right: 0;
}
.index-goods.shop_show_healthNursing .goods-list ul li:nth-last-child(2) {
  border-bottom: none;
}
.index-goods.shop_show_healthNursing .goods-list ul li a .area {
  padding: 0 10px;
}
.index-goods.shop_show_healthNursing .goods-list li .limit img {
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/style/goods/shop_show_small_big.vue